
// order has properties for saving sums of freightLine values - but there is one mismatch property name mistmatch between freightLine
// property, and the order property. This map object is used to deal with this.

export let mapOrderSumKeysToFreightLineKey = {
	numberOfPackages: 'numberOfUnits',
	numberOfPallets: 'numberOfPallets',
	loadingMeters: 'loadingMeters',
	volume: 'volume',
	grossWeight: 'grossWeight',
	chargableWeight: 'chargableWeight',
};
